(function () {
  'use strict';

  if (window.BloomingfulChat && window.BloomingfulChat.guardVersion) return;

  var managedByGuard = false;
  var restoreVisibility = 'minimized';
  var widgetBound = false;
  var syncTimer = null;
  var connectAttempts = 0;
  var maxConnectAttempts = 120;
  var customerIdentityApplied = false;

  function getWidget() {
    if (!window.LiveChatWidget || typeof window.LiveChatWidget.call !== 'function') return null;
    return window.LiveChatWidget;
  }

  function getVisibility() {
    var widget = getWidget();
    if (!widget || typeof widget.get !== 'function') return null;

    try {
      var state = widget.get('state');
      return state && state.visibility ? state.visibility : null;
    } catch (error) {
      return null;
    }
  }

  function callWidget(method, data) {
    var widget = getWidget();
    if (!widget) return false;

    try {
      if (typeof data === 'undefined') {
        widget.call(method);
      } else {
        widget.call(method, data);
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function applyCustomerIdentity() {
    if (customerIdentityApplied) return;

    var customer = window.BloomingfulLiveChatCustomer;
    if (!customer || !customer.email) return;

    var nameApplied = !customer.name || callWidget('set_customer_name', customer.name);
    var emailApplied = callWidget('set_customer_email', customer.email);
    customerIdentityApplied = Boolean(nameApplied && emailApplied);
  }

  function hasBlockingSurface() {
    var root = document.documentElement;
    var refreshNotice = document.querySelector('.bf-site-refresh.is-visible:not([hidden])');
    var openDrawer = document.querySelector('.drawer.drawer--is-open');

    return Boolean(
      refreshNotice ||
      openDrawer ||
      root.classList.contains('modal-open') ||
      root.classList.contains('video-modal-open')
    );
  }

  function syncVisibility() {
    var visibility = getVisibility();
    if (!visibility) return;

    if (hasBlockingSurface()) {
      if (!managedByGuard) {
        if (visibility === 'hidden') return;
        restoreVisibility = visibility === 'maximized' ? 'maximized' : 'minimized';
        managedByGuard = true;
      }

      if (visibility !== 'hidden') callWidget('hide');
      return;
    }

    if (!managedByGuard) return;

    managedByGuard = false;
    callWidget(restoreVisibility === 'maximized' ? 'maximize' : 'minimize');
    restoreVisibility = 'minimized';
  }

  function queueSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncVisibility, 30);
  }

  function openChat(options) {
    options = options || {};
    if (managedByGuard) restoreVisibility = 'maximized';

    var payload = options.messageDraft ? { messageDraft: options.messageDraft } : undefined;
    var opened = callWidget('maximize', payload);
    queueSync();
    return opened;
  }

  function bindWidget() {
    var widget = getWidget();
    if (!widget) return false;

    if (!widgetBound && typeof widget.on === 'function') {
      widgetBound = true;
      widget.on('ready', function () {
        applyCustomerIdentity();
        queueSync();
      });
      widget.on('visibility_changed', function () {
        if (managedByGuard) queueSync();
      });
    }

    applyCustomerIdentity();
    queueSync();
    return true;
  }

  window.BloomingfulChat = {
    guardVersion: '2026-08-10-customer-identity',
    open: openChat,
    refresh: queueSync
  };

  var observer = new MutationObserver(queueSync);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'hidden'],
    childList: true,
    subtree: true
  });

  document.addEventListener('drawerOpen', queueSync);
  document.addEventListener('modalOpen', queueSync);
  document.addEventListener('DOMContentLoaded', queueSync);

  if (!bindWidget()) {
    var connectTimer = window.setInterval(function () {
      connectAttempts += 1;
      if (bindWidget() || connectAttempts >= maxConnectAttempts) {
        window.clearInterval(connectTimer);
      }
    }, 250);
  }
})();
